import React, { Component } from 'react'
import JewelryPanel from '../jewelry-panel'
import Spacer from '../../spacer'
import Select from '../../select'
import SelectItem from '../../select-item'
import SelectShapes from '../../select-shapes'
import Input from '../../input'
import Button from '../../button'
import CrossIcon from 'react-icons/lib/fa/close'
import MultiStoneShapes from '../../select-shapes/multi_stone_shapes'
import _ from 'lodash'

class AdditionalDiamondPanel extends Component {
  componentDidUpdate (prevProps) {
    const props = this.props
    if (props.additional_diamond_quality && props.additional_diamond_shape && (props.additional_diamond_quality !== prevProps.additional_diamond_quality || props.additional_diamond_shape !== prevProps.additional_diamond_shape)) {
      props.onSetAdditionalDiamondSizeOptions(props.additionalDiamondId, props.additional_diamond_shape, props.additional_diamond_quality)
    }
  }

  render () {
    const props = this.props

    const onInputChange = (field, val) => {
      let inputVal = (field !== 'additional_diamond_shape') ? val : val[0]
      props.onUpdateAdditionalDiamond(props.additionalDiamondId, field, inputVal)
    }

    const getAdditionalDiamondSettingStyleOptions = () => {
      const disablePave = () => props.additional_diamond_shape !== 'round_shape' || props.jewelry_type === 'StockItem'
      const disablePaveBorder = () => props.additional_diamond_shape !== 'round_shape' || props.jewelry_type === 'StockItem'
      const disableChannelSet = () => !_.includes(['round_shape', 'princess', 'straight_baguette'], props.additional_diamond_shape) || props.jewelry_type === 'StockItem'
      const disableBezelSet = () => props.jewelry_type === 'StockItem'
      const disableFlushSet = () => !_.includes(['round_shape', 'princess'], props.additional_diamond_shape)
      const disableSharedClaw = () => !_.includes(['round_shape', 'princess', 'straight_baguette', 'oval', 'cushion', 'radiant', 'emerald', 'asscher'], props.additional_diamond_shape) || props.jewelry_type === 'StockItem'
      return [
        { value: 'pave', label: 'Pavé', disabled: disablePave() },
        { value: 'pave_border', label: 'Pavé w/ Border', disabled: disablePaveBorder() },
        { value: 'channel_set', label: 'Channel Set', disabled: disableChannelSet() },
        { value: 'bezel_set', label: 'Bezel Set', disabled: disableBezelSet() },
        { value: 'flush_set', label: 'Flush Set', disabled: disableFlushSet() },
        { value: 'shared_claw_set', label: 'Shared Claw', disabled: disableSharedClaw() },
        { value: 'centre_diamond_setting', label: 'Prong/Centre Set' }
      ]
    }

    const getAdditionalDiamondQualityOptions = () => {
      return [
        {value: 'standard', label: 'Standard'},
        {value: 'plus', label: 'Plus'},
        {value: 'lab_grown', label: 'Lab Grown'},
      ]
    }

    return (
      <JewelryPanel
        id={`${props.additionalDiamondId}-additional_diamond_container`}
        show
        isResetting={props.isResetting}>

        <h4>Additional Diamond Quantity</h4>
        <Input
          inputId={`${props.additionalDiamondId}-additional_diamond_quantity`}
          type='number'
          step={1}
          value={props.additional_diamond_quantity}
          onChange={(e) => { onInputChange('additional_diamond_quantity', e.target.value) }}
        />

        <Spacer xxs />

        <h4>Additional Diamond Shape</h4>

        <SelectShapes
          id={`${props.additionalDiamondId}-additional_diamond_shape`}
          single
          listFor={'multi_stone'}
          value={props.additional_diamond_shape}
          onChange={(val) => { onInputChange('additional_diamond_shape', val) }}
          shapes={MultiStoneShapes}
          initVal={[]}
        />

        <Spacer xxxs />

        <SelectItem
          label='Additional Diamond Quality'
          id={`${props.additionalDiamondId}-additional_diamond_quality`}
          labelId={`${props.additionalDiamondId}-additional_diamond_quality-label`}
          options={getAdditionalDiamondQualityOptions()}
          value={props.additional_diamond_quality}
          onChange={(val) => { onInputChange('additional_diamond_quality', val) }}
        />

        <Spacer xxs />

        <h4>Additional Diamond Size (mm)</h4>
        <Select
          multi={false}
          options={props.size_options}
          value={props.small_diamond_id}
          onChange={(val) => { onInputChange('small_diamond_id', val) }}
          matchPos='start'
          matchProp='label'
          disabled={!(props.additional_diamond_shape && props.additional_diamond_quality)}
        />

        <Spacer xxs />

        <SelectItem
          label='Additional Diamond Setting Style'
          labelId={`${props.additionalDiamondId}-additional_diamond_setting_style-label`}
          id={`${props.additionalDiamondId}-additional_diamond_setting_style`}
          options={getAdditionalDiamondSettingStyleOptions()}
          value={props.additional_diamond_setting_style}
          onChange={(val) => { onInputChange('additional_diamond_setting_style', val) }}
        />

        <Spacer xxs />

        <Button alt id={`${props.additionalDiamondId}-remove-btn`} onClick={() => props.onClickRemoveAdditionalDiamond(props.additionalDiamondId)}>
          <i><CrossIcon /></i> Remove
        </Button>

        <Spacer lg />

      </JewelryPanel>
    )
  }
}

export default AdditionalDiamondPanel



// WEBPACK FOOTER //
// ./src/components/jewelry-search-filters/additional-diamond-panel/index.js